{
  "title": "Retuur & Fey Delloo",
  "request_title": "Ñaane retuur",
  "my_returns": "Sama retuur yi",
  "no_returns": "Amul retuur",
  "no_returns_description": "Defoo woon ñaane retuur.",
  "policy": {
    "title": "Politig retuur",
    "window": "Am nga {{days}} fan ginnaaw indil bi ngir ñaane retuur.",
    "deadline": "Bés bu mujj ngir retuur : {{date}}",
    "photos_required": "Nataal yi dañu koy soxla ci ñaane bii.",
    "auto_approve_notice": "Retuur yi nekk ci suuf {{amount}} FCFA dañu koy nangu ci kaw."
  },
  "reasons": {
    "DEFECTIVE": "Produwe bu yàqu",
    "WRONG_ITEM": "Produwe bu baaxul — benn laa woon bëgg",
    "NOT_AS_DESCRIBED": "Dëkkul ak li ñu tekki",
    "CHANGED_MIND": "Soppi naa xel",
    "EXPIRED": "Produwe bu jeex",
    "OTHER": "Yeneen"
  },
  "status": {
    "REQUESTED": "Ñaane na",
    "APPROVED": "Nangu nañu ko",
    "PICKUP_SCHEDULED": "Ñu tànn bés jëleem bi",
    "RECEIVED": "Jot na",
    "REFUND_PROCESSING": "Fey delloo ci kanam",
    "REFUND_COMPLETED": "Delloo nañu fey bi",
    "REJECTED": "Bañ nañu ko"
  },
  "refund_methods": {
    "ORIGINAL_PAYMENT": "Yoonu fey bi woon",
    "WAVE": "Wave",
    "ORANGE_MONEY": "Orange Money",
    "STORE_CREDIT": "Kreedi bitik"
  },
  "form": {
    "step_items": "Tànn produwe yi",
    "step_reason": "Ngirte retuur bi",
    "step_details": "Biri-biri ak nataal",
    "step_review": "Xool",
    "select_items": "Tànn produwe yi ngay delloo",
    "quantity": "Limu",
    "reason_label": "Ngirte retuur bi",
    "reason_placeholder": "Tànn benn ngirte",
    "description_label": "Tekki njuumte bi",
    "description_placeholder": "Tekkalal njuumte bi ci sa komand...",
    "photos_label": "Nataal (du waajib)",
    "photos_hint": "Yokk nataal ngir ndimbal ñu ci ñaane bi.",
    "review_order": "Komand",
    "review_items": "Produwe yi ngay delloo",
    "review_reason": "Ngirte",
    "review_description": "Tekki",
    "review_refund_estimate": "Fey delloo bu ñu mën la jox",
    "submit": "Yonnee ñaane bi",
    "submitting": "Yonnee ci kanam...",
    "cancel": "Neenal",
    "next": "Ci kanam",
    "previous": "Ci ginnaaw",
    "success_title": "Ñaane bi yonnee na bu baax",
    "success_message": "Sa ñaane retuur bi denc na. Sunu ekip dina ko xool ci biir 48 waxtu.",
    "success_ref": "Réf. retuur : {{id}}",
    "error_no_items": "Tànnal benn produwe bu gën a ndaw.",
    "error_no_reason": "Tànnal benn ngirte.",
    "error_no_description": "Tekkal njuumte bi.",
    "error_generic": "Am na njuumte. Jéemal ko."
  },
  "card": {
    "order_ref": "Komand {{ref}}",
    "created_on": "Ñaane ci {{date}}",
    "resolved_on": "Mucc ci {{date}}",
    "refund_amount": "Tollu fey delloo",
    "refund_method": "Yoonu fey delloo",
    "rejection_reason": "Li tax ñu bañ",
    "items_count": "{{count}} produwe",
    "items_count_plural": "{{count}} produwe",
    "tracking": "Topp"
  },
  "filter": {
    "all": "Yépp",
    "active": "Ci kanam",
    "completed": "Jeex na"
  },
  "loading": "Yéegal retuur yi...",
  "error_loading": "Mënuñu yéegal sa retuur yi."
}
